import { Observable } from 'rxjs';
import { RefundPolicyResponse } from '../models/refund-policy-response.model';

export abstract class RefundPolicyRepository {
    abstract getRefundPolicy(): Observable<RefundPolicyResponse>;
}
